<template>
    <div v-if="items && items.length"
         :class="`plan-basket${this.contained ? ' --contained' : ''}`">
        <div :class="`plan-basket__scroll-mask plan-basket__scroll-mask--top${this.contained ? ' --contained' : ''}`" />
        <ul :class="`plan-basket__items${this.contained ? ' --contained' : ''}`">
            <item v-for="item in items"
                  :key="item.id"
                  :item="item"
                  :display-type="displayType"
                  :editable="editable"
                  :primary="!contained"
                  @remove="onRemoveItem" />
        </ul>
        <div :class="`plan-basket__scroll-mask plan-basket__scroll-mask--bottom${this.contained ? ' --contained' : ''}`" />
        <div v-if="!$scheme.priceless" class="plan-basket__cost">
            <span class="plan-basket__cost__label">Estimated Cost</span>
            <span class="plan-basket__cost__value">{{ totalCost }}</span>
        </div>
    </div>
</template>

<script>

import Vuex from 'vuex'

import Project from '@/models/project'

import PlanBuilderManager from '@/plan-builder-manager'

import Item from './plan-basket-item'

export default {

    props: {
        contained: {
            type: Boolean,
            default: false,
        },
        displayType: {
            type: String,
            default: 'standard',
        },
        editable: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {Project}
             */
            currentProject: stateStore => Project.ensure(stateStore.improvements.currentProject),
        }),

        items() {
            return this.currentProject.addedImprovements
        },

        totalCost() {
            return this.currentProject.costDisplay
        },
    },

    methods: {

        onRemoveItem(itemId) {
            const item = this.items.find(i => i.id === itemId)

            if (item)
                PlanBuilderManager.removeImprovementFromProjectAsync(item)
            else
                this.$logger.warn(`Attempted to remove an invalid item from the basket with ID: ${ itemId }`)
        },
    },

    components: {
        Item,
    },

    Item,
}

</script>

<style lang="scss">

.plan-basket {
    position: relative;

    @include element('items') {
        @include unstyle-list;
        margin-bottom: 0.5rem;

        @include bp-min-mid {
            overflow-y: auto;
            overflow-x: hidden;
            max-height: rem(calc(100% - 34px));
        }

        &.--contained {
            overflow-y: auto;
            overflow-x: hidden;
            max-height: rem(calc(100% - 360px));
        }

        > * {
            &:first-child {
                margin-top: 0.4rem;
            }
            &:last-child {
                margin-bottom: 0.4rem;
            }
        }
    }

    @include element('scroll-mask') {

        &:before, &:after {
            display: none !important;
        }

        @include bp-min-mid {

            &:before, &:after {
                display: block !important;
            }
        }

        @include modifier('top') {
            position: relative;
            top: rem(-2px);

            &.--contained {

                &:before {
                    display: none !important;
                }
            }
        }

        @include modifier('bottom') {
            position: relative;
            bottom: rem(5px);

            &.--contained {

                &:after {
                    display: block !important;
                }
            }
        }
    }

    @include element('cost') {
        display: table;
        width: 100%;

        @include element('label') {
            display: table-cell;

            &:after {
                content: ':'
            }
        }

        @include element('value') {
            display: table-cell;
            text-align: right;
            font-size: 1.5rem;
            line-height: 1.8rem;
        }
    }
}

</style>
